import {NgModule, LOCALE_ID, CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {RouteReuseStrategy} from '@angular/router';
import {IonicModule, IonicRouteStrategy} from '@ionic/angular';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {AdminSideMenuComponent} from './components/core/admin-side-menu/admin-side-menu.component';
import {CustomerSideMenuComponent} from './components/core/customer-side-menu/customer-side-menu.component';
import {HTTP_INTERCEPTORS, HttpClientModule} from "@angular/common/http";
import {AuthInterceptor} from "./app.auth.interceptor";
import {AppPipesModule} from './app-pipes.module';
import {NgChartsModule} from 'ng2-charts';
import {NgxStripeModule} from "ngx-stripe";

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [AppComponent, AdminSideMenuComponent, CustomerSideMenuComponent],
  imports: [
    BrowserModule,
    IonicModule.forRoot({
      innerHTMLTemplatesEnabled: true
    }),
    NgxStripeModule.forRoot(),
    AppRoutingModule,
    HttpClientModule,
    AppPipesModule,
    NgChartsModule
  ],
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: LOCALE_ID, useValue: 'de-de' },
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
